import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-timeout",
  standalone: true,
  imports: [TranslateModule],
  templateUrl: "./timeout.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./timeout.component.scss",
})
export class TimeoutComponent {}
